{
  "buttons": {
    "primaryAction": {
      "create": "Create",
      "next": "Next",
      "save": "Save",
      "done": "Done"
    }
  },
  "warning": {
    "changeCustomSort": "Changing the sort order will remove your custom sorting.",
    "scheduleForLater": "Please select a time at least 15 minutes in the future.",
    "zeroEnrollmentCount": "The segments selected do not contain enrolled campers. Please revise your segment selection."
  },
  "steps": {
    "compose": {
      "constraintsPill": {
        "allAudiences": "Everyone",
        "customAudience": "Custom Audience"
      }
    },
    "schedule": {
      "title": "When would you like to publish your album?",
      "description": "You can publish the album now or schedule for later.",
      "datenotice": "Note: Publish date must be 10 or more minutes in the future",
      "options": {
        "schedulenow": {
          "title": "Publish Now",
          "description": "Publish your album immediately. Published albums can not be moved to draft once published."
        },
        "saveasdraft": {
          "title": "Save as Draft",
          "description": "Album is saved as draft and is only visible to you."
        },
        "scheduleforlater": {
          "title": "Schedule for Later",
          "description": "Select a time to publish your album."
        }
      }
    },
    "published": {
      "title": "Your album has been published",
      "description": "If you'd like to delete an album, select \"Delete\" from the album options in the top right corner of each album thumbnail."
    }
  },
  "banner": {
    "staffEngagement": "All active Staff will be able to view albums even if Audience Segments are applied."
  }
}
